import { render, staticRenderFns } from "./AppEventSlider.vue?vue&type=template&id=d19924ba&scoped=true&"
import script from "./AppEventSlider.vue?vue&type=script&lang=js&"
export * from "./AppEventSlider.vue?vue&type=script&lang=js&"
import style0 from "./AppEventSlider.vue?vue&type=style&index=0&id=d19924ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19924ba",
  null
  
)

export default component.exports